export const STATES_BRAZIL = [
  {
    id: 999,
    value: '',
    name: 'Selecione',
  },
  {
    id: 11,
    value: 'RO',
    name: 'Rondônia',
  },
  {
    id: 12,
    value: 'AC',
    name: 'Acre',
  },
  {
    id: 13,
    value: 'AM',
    name: 'Amazonas',
  },
  {
    id: 14,
    value: 'RR',
    name: 'Roraima',
  },
  {
    id: 15,
    value: 'PA',
    name: 'Pará',
  },
  {
    id: 16,
    value: 'AP',
    name: 'Amapá',
  },
  {
    id: 17,
    value: 'TO',
    name: 'Tocantins',
  },
  {
    id: 21,
    value: 'MA',
    name: 'Maranhão',
  },
  {
    id: 22,
    value: 'PI',
    name: 'Piauí',
  },
  {
    id: 23,
    value: 'CE',
    name: 'Ceará',
  },
  {
    id: 24,
    value: 'RN',
    name: 'Rio Grande do Norte',
  },
  {
    id: 25,
    value: 'PB',
    name: 'Paraíba',
  },
  {
    id: 26,
    value: 'PE',
    name: 'Pernambuco',
  },
  {
    id: 27,
    value: 'AL',
    name: 'Alagoas',
  },
  {
    id: 28,
    value: 'SE',
    name: 'Sergipe',
  },
  {
    id: 29,
    value: 'BA',
    name: 'Bahia',
  },
  {
    id: 31,
    value: 'MG',
    name: 'Minas Gerais',
  },
  {
    id: 32,
    value: 'ES',
    name: 'Espírito Santo',
  },
  {
    id: 33,
    value: 'RJ',
    name: 'Rio de Janeiro',
  },
  {
    id: 35,
    value: 'SP',
    name: 'São Paulo',
  },
  {
    id: 41,
    value: 'PR',
    name: 'Paraná',
  },
  {
    id: 42,
    value: 'SC',
    name: 'Santa Catarina',
  },
  {
    id: 43,
    value: 'RS',
    name: 'Rio Grande do Sul',
  },
  {
    id: 50,
    value: 'MS',
    name: 'Mato Grosso do Sul',
  },
  {
    id: 51,
    value: 'MT',
    name: 'Mato Grosso',
  },
  {
    id: 52,
    value: 'GO',
    name: 'Goiás',
  },
  {
    id: 53,
    value: 'DF',
    name: 'Distrito Federal',
  },
];

export const TYPE_PRODUCTS = [
  {
    id: 999,
    value: '',
    name: 'Selecione',
  },
  {
    id: 1,
    value: 'SERVICE',
    name: 'Serviço',
  },
  {
    id: 2,
    value: 'PRODUCT',
    name: 'Produto',
  },
  {
    id: 3,
    value: 'GIFT',
    name: 'Prêmio',
  },
];

export const TYPE_FILTER = [
  {
    id: 0,
    value: 'Selecione',
    name: 'Selecione',
  },
  {
    id: 1,
    value: 'Todos',
    name: 'Todos',
  },
  {
    id: 2,
    value: 'Pre Venda',
    name: 'Pre Venda',
  },
  {
    id: 3,
    value: 'Devedores',
    name: 'Devedores',
  },
  {
    id: 4,
    value: 'Pagamentos',
    name: 'Pagamentos',
  },
];
